// 公共的请求方法
import axios from '../utils/request'
let API = ''
// let API = 'http://shulianyun.baiyishequ.com';

const api = {
  API,
  // 登录接口
  postAccountLogin(paramsJson) {
    var params = new URLSearchParams()
    for (var key in paramsJson) {
      params.append(key, paramsJson[key])
    }
    return axios.post(API + '/api/user/userAuth.api.php?act=accountLogin', params)
  },
  // 字典
  getLoginPage() {
    return axios.get(API + '/api/user/userAuth.api.php?act=loginPage', {
      params: {},
    })
  },
  // 发送短信验证码
  postSmsVerify(paramsJson) {
    var params = new URLSearchParams()
    for (var key in paramsJson) {
      params.append(key, paramsJson[key])
    }
    return axios.post(API + '/api/user/userAuth.api.php?act=smsVerify', params)
  },
  // 二次校验登录
  accountLogin2(paramsJson) {
    var params = new URLSearchParams()
    for (var key in paramsJson) {
      params.append(key, paramsJson[key])
    }
    return axios.post(API + '/api/user/userAuth.api.php?act=accountLogin2', params)
  },
}

export default api
